module.exports = __webpack_public_path__ + "static/media/banner19.02c7478d.jpg";